import { format, parseISO, isValid } from 'date-fns'

export function formatDate(value: string, dateFormat = 'Pp') {
  if (!value) return ''
  let date = parseISO(value)
  if (!isValid(date)) {
    date = new Date(value)
  }
  if (!isValid(date)) {
    return value
  }
  try {
    return format(date, dateFormat)
  } catch {
    return value
  }
}
